// @flow

import React from 'react';
import { Redirect, Route, Switch } from 'react-router';

import Loadable from '../components/Loadable';
import Layout from './components/Layout';
import { Container } from './components';
import Welcome from './Welcome';

import { connectToUser } from '../UserProvider';

const Preload = () => <Layout title={'Loading...'} />;

const Signup = connectToUser(
  Loadable({
    loader: () => import(/* webpackChunkName: "auth-signup" */ './Signup'),
    loading: Preload,
  })
);

const Login = connectToUser(
  Loadable({
    loader: () => import(/* webpackChunkName: "auth-login" */ './Login'),
    loading: Preload,
  })
);

const ActivePage = (props: Object) => {
  return (
    <Container>
      <Switch>
        <Route path="/signup" component={Signup} />
        <Route path="/login" component={Login} />
        <Route exact path="/" component={Welcome} />
        <Redirect to="/" />
      </Switch>
    </Container>
  );
};

export default ActivePage;



// WEBPACK FOOTER //
// ./src/Auth/Root.js